export default {
  id: 'molten.geoPoint.FartherThan.ComparatorFilterConverter',
  type: 'geoPoint.FartherThan',
  convert: (cmp, attribute) => {
    if (cmp?.value1 == null) {
      return null;
    }
    const distance = `${cmp.distance}${cmp.units}`;
    return {
      type: 'geoDistance',
      location: cmp.value1,
      distance,
      field: attribute.blueprint.field,
      not: true
    };
  }
};